(function($) {

    /**
     * Gestionnaire du spécifique sur site
     */
    var website = {

        /**
         * Méthode déclenchée au chargement du site
         */
        init: function() {

            //website.afterLoad();

            // Connection du gestionnaire de redimensionnement
            //$(window).resize(self.resizeHandler());
        	
           
            $(".bx-loading").hide();
            
            website.prepareSubCategoyPage();
            
            //Mehode pour la navigation des annees dans la page Histoire 
            website.historyNav();
            
            website.mosaicBanShowPopine();
            website.newsLetterChoiseTitle();
        	
        	
            
        },
        /**
         * Méthode déclenchée après chaque chargement de chaque page
         */
        afterload: function(){

        },

        /**
         * Méthode pour vérifier le mobile
         */
        isMobile: function(){

        },
        /**
         * Cette méthode est appelée à chaque changement de taille du navigateur
         */
        resizeHandler: function() {

            
        },
       prepareSubCategoyPage : function(){
    	   if ($(".list-product .list-content .elligibleComapre").length < 2) {
    		   $(".list-product .item-compare").remove();
    	   }
       },
       /**
        * Methode pour le menu des annees dans la page Histoire de marque 
        */
       historyNav : function(){
    	   
    	   $("#history-nav a").on("click", function (e) {
    	        e.preventDefault();
    	        $("#history-nav a").removeClass('active');
    	        var t = $($(this).attr("href"));
    	        $('html, body').animate({
    	            scrollTop: t.offset().top - 163
    	        }, 'slow');
    	        $(this).addClass('active');
    	    });
       },
       /**
        * Methode pour afficher la popine dans le bloc Mosaic
        */
       mosaicBanShowPopine : function(){
    	   
    	   //Open popin
    	   $(".mosaic-ban .mosaic-zone").on("click", function (e) {
    		   
    		   if($(e.target).is('button.close-popine') || $(e.target).is('.ico-close')){
    			   e.preventDefault();
    			   $(".mosaic-ban .content-popine").removeClass('active');
	   	        return;
    		   }
    		   e.preventDefault();
	   	        $(".mosaic-ban .content-popine").removeClass('active');

	   	        $(this).find(".content-popine").addClass('active');
	   	    });
    	   
    	   //Close popine
    	   $(".mosaic-ban .close-popine").on("click", function (e) {
    		   
    		   e.preventDefault();
    		   
    		   $(".mosaic-ban .content-popine").removeClass('active');
    		   
    	   });
    	   
    	   
       },
       /**
        * 
        * Methode pour afficher le titre de la popine newsletter dans tunnel
        * 
        */
       newsLetterChoiseTitle : function(){
    	   
    	   //
    	   if($("#NewsLetterChoise .title-modal-news").length > 0 ){
    		   
    		   // get text from old title
    		   var newsTitle = $("#NewsLetterChoise .title-modal-news").text();
    		   
    		   // remove old title
    		   $("#NewsLetterChoise .title-modal-news").remove();
    		   
    		   //Add title
    		   $("#NewsLetterChoise  .modal-header").html("<h3>"+newsTitle+"</h3>");
    	   }
    	   
    	   if($("#PaymentMode .span8 p").length > 0 ){
		   
		   // get text from old title
		   var PaymentModeTitle = $("#PaymentMode .span8 p").text();
		   
		   // remove old title
		   $("#PaymentMode .span8 p").remove();
		   
		   //Add title
		   $("#PaymentMode  .modal-header").html("<h3>"+PaymentModeTitle+"</h3>");
	   }
    	   
    	
    	   
    	   
       }
       
    };
    /**
     * Initialisation du gestionnaire de site
     */
    $(document).ready(function() {
        website.init();
    });
})(jQuery);
